import { RootState } from 'Store/index';

export const selectActiveKey = (state: RootState) => state.LayoutReducer.activeKey